// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoBlockForm_root__9UNzL"};